var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.75,
    viewBox: "0 0 20 20.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19180",
    "data-name": "Group 19180",
    transform: "translate(-314 -108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-check-in-6432169",
    d: "M125.771,123.673h-12.5a.8.8,0,0,1,0-1.6h12.5l-1.764-1.83a.82.82,0,0,1,0-1.129.75.75,0,0,1,1.088,0l3.077,3.192a.82.82,0,0,1,0,1.129l-3.077,3.192a.748.748,0,0,1-1.087,0,.82.82,0,0,1,0-1.129l1.764-1.83Zm4.934-11.173H122.5a1.831,1.831,0,0,0-1.795,1.862v2.128a.77.77,0,1,0,1.538,0v-2.128a.261.261,0,0,1,.256-.266h8.205a.262.262,0,0,1,.256.266v17.026a.262.262,0,0,1-.256.266H122.5a.262.262,0,0,1-.256-.266V129.26a.77.77,0,1,0-1.538,0v2.128a1.831,1.831,0,0,0,1.795,1.862h8.205a1.831,1.831,0,0,0,1.795-1.862V114.362A1.831,1.831,0,0,0,130.705,112.5Z",
    transform: "translate(201.5 -4.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/checkIn.7236b2de52272b825030d0c672b55874.svg";
export { ForwardRef as ReactComponent };